import { makeRule } from '@utils/rule'

export let formRules = {
  tagname: [
    {...makeRule('请输入标签名称')},
    {...makeRule('请输入1-20个字符', 'string'), min: 1, max: 20},
  ],
}



// WEBPACK FOOTER //
// ./src/views/user-tag/userTag.rules.js